module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Uploaded-file-59760d85db0ed1e17836bcd2b5f5f3f6.svg";